/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Summary_No_FilterInputs */

const en_views_summary_no_filter = /** @type {(inputs: Views_Summary_No_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No filter`)
};

const de_views_summary_no_filter = /** @type {(inputs: Views_Summary_No_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Filter`)
};

/**
* | output |
* | --- |
* | "No filter" |
*
* @param {Views_Summary_No_FilterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_summary_no_filter = /** @type {((inputs?: Views_Summary_No_FilterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Summary_No_FilterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_summary_no_filter(inputs)
	return en_views_summary_no_filter(inputs)
});